export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11918.b1098fb6.jpg";